import { withInterstitial } from 'wanderu-component-page-loader';
import { ScrollToTopOnMount } from 'wanderu-hocs';

const TripSummaryPage = withInterstitial(import('./pages/TripSummary'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});

export default [
    {
        path: '/tripsummary/:outboundTripId/:returnTripId?/',
        key: 'tripsummary',
        component: ScrollToTopOnMount(TripSummaryPage),
    },
];
